import { IKVMap, IState } from './state';
import { MutationTree } from 'vuex';

export default {
    addTheme(state, theme) {
        state.themes.push(theme);
    },
    setIsFormSending(state, isSending: boolean) {
        state.isFormSending = isSending;
    },
    setFormValue(state: IState, { key, value }) {
        const v = (<IKVMap<any>>state.userForm)[key];

        const newValue = typeof v === 'string'
            ? value
            : v.replaceValue(value);

        state.userForm = {
            ...state.userForm,
            [key]: newValue
        };
    },
    setCountry(state, country: string) {
        state.country = country;
    },
    setStepHeadlines(state, stepHeadlines: {}) {
        state.stepHeadlines = stepHeadlines;
    },
    setTravelThemes(state, travelThemes: {}) {
        state.travelThemes = travelThemes;
    },
    currentStepUp(state) {
        state.currentStep++;
    },
    setIsLoading(state, isLoading: boolean) {
        state.isLoading = isLoading;
    },
    setDataPolicy(state, { value, checksum: __datapolicy_checksum, type: __datapolicy_type }) {
        state.userForm = {
            ...state.userForm,
            __datapolicy_checksum,
            __datapolicy_type,
            dataPolicyAccepted: state.userForm.dataPolicyAccepted.replaceValue(value),
        };
    }
} as MutationTree<IState>
